import { useTranslation } from "react-i18next";
import * as yup from "yup";

const useFoldersStructureXmlFileSchema = () => {
    const { t } = useTranslation();

    return yup.object({
        fileType: yup.string().required(t("messages.inputMsgs.required")),
        selectableFileName: yup.string(),
        textFileName: yup.string(),
    });
};

export default useFoldersStructureXmlFileSchema;
